import { Table } from 'react-bootstrap';
import AccordionCard from '../AccordionCard';

const TaxBalanceFormatOld = () => {
  return (
    <>
      <AccordionCard title="Format Table" parent="taxBalanceAccordion">
        <p className="fs-5 fst-italic mb-1">
          The tax balance is assumed 2 decimal places. Filled with leading zeroes.
        </p>
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Position</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Position 1</td>
              <td>Always “P” for Property Record</td>
            </tr>
            <tr>
              <td>Positions 2- 27</td>
              <td>Tax year, followed with spaces.</td>
            </tr>
            <tr>
              <td>Positions 28 - 36</td>
              <td>Property Serial Number</td>
            </tr>
            <tr>
              <td>Positions 37 - 43</td>
              <td>Tax Reference</td>
            </tr>
            <tr>
              <td>Positions 44 - 53</td>
              <td>Padded with zeroes</td>
            </tr>
            <tr>
              <td>Positions 54 - 63</td>
              <td>Padded with zeroes</td>
            </tr>
            <tr>
              <td>Positions 64 - 73</td>
              <td>Tax Balance Due &#40;amount to submit with final payment&#41;</td>
            </tr>
            <tr>
              <td>Positions 74 - 120</td>
              <td>&#39;D&#39; if delinquent for prior years, then blank.</td>
            </tr>
            <tr>
              <td>Example</td>
              <td>
                P2010 0100100010000018000000000000000000000000100631 <br />
                P2010 0100100030000026000000000000000000000000113457
              </td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
    </>
  );
};

export default TaxBalanceFormatOld;
